/*
  Product-card star ratings.

  Stamped fills its badges asynchronously, so the average is only known once the
  widget has answered. This hides any card whose average sits below the theme
  minimum (Theme settings > Product card > "Hide ratings below") and reveals the
  rest. The badge starts hidden in CSS so a low rating never flashes on screen.
*/
(function () {
  var SETTLE_MS = 20000;

  function evaluate(row) {
    var badge = row.querySelector('.stamped-badge');
    if (!badge) return false;

    var min = parseFloat(row.getAttribute('data-rating-min'));
    var rating = parseFloat(badge.getAttribute('data-rating'));
    if (isNaN(min)) min = 0;

    if (!isNaN(rating) && rating < min) row.classList.add('is-below-min');
    row.classList.add('is-ready');
    return true;
  }

  function scan() {
    var pending = 0;
    var rows = document.querySelectorAll('[data-card-rating]:not(.is-ready)');
    for (var i = 0; i < rows.length; i++) {
      if (!evaluate(rows[i])) pending++;
    }
    return pending;
  }

  function start() {
    if (scan() === 0) return;

    var queued = false;
    var observer = new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        if (scan() === 0) observer.disconnect();
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });

    // products with no reviews never get a badge — stop watching eventually
    setTimeout(function () { observer.disconnect(); }, SETTLE_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
